package fyi.moko.hotpl.domain.model

import kotlinx.serialization.Serializable

@Serializable
enum class PlaceStatus {
    VISITED,
    WISHLIST,
    DISMISSED
}

@Serializable
enum class Visibility {
    PRIVATE,
    FRIENDS,
    PUBLIC
}

@Serializable
enum class SyncState {
    SYNCED,
    PENDING_UPSERT,
    PENDING_DELETE,
    CONFLICT
}

enum class SyncAction {
    UPSERT,
    DELETE
}

@Serializable
enum class RevisitCadence {
    ANYTIME,
    OCCASIONAL,
    SPECIAL,
    ANNUAL,
}

@Serializable
enum class CostFeel {
    LOW,
    MEDIUM,
    HIGH,
    SPECIAL_OCCASION,
}
